import { mapAgeRestrictedSetting } from '../helpers'

export const DTOProductsObjectiveBased = (products: CatalogProduct[]) => {
  return products.map(item => ({
    id: item.id ? String(item.id) : undefined,
    sku: item.product_sku ? String(item.product_sku) : undefined
  }))
}

export const DTOCreateObjectiveBasedCampaign = (
  data: DTOCreateObjectiveBasedCampaignPayload
) => {
  const { lengthCentsCurrency } = data

  const products = DTOProductsObjectiveBased(data?.products || [])

  const dailyBudgetRaw = data.daily_budget.numAsString
  const dailyBudget = lengthCentsCurrency
    ? Number(dailyBudgetRaw) / 100
    : Number(dailyBudgetRaw)

  const body: DTOCreateObjectiveBasedCampaignResponse = {
    ad_type: 'product',
    goal: data.goal,
    name: data.name,
    products,
    start_at: data.start_at,
    end_at: data.end_at,
    publisher_id: data.publisherId,
    daily_budget: dailyBudget,
    settings: mapAgeRestrictedSetting(data.settings)
  }

  return body
}
